const details = [
    {
        field: "INTERNSHIP", 
        logo: "https://cdn.discordapp.com/attachments/918024642860548126/1092100022906142821/logo-png-square.webp",
        name: "Codelance Devs",
        link: "https://codelancedevs.com",
        duration: "Feb 2023 - Present",
        workexp1: "~ Full Stack Developer Intern.",
        workexp2: "~ Worked on 2 freelance projects.",
        workexp3: "~ Collaborated with team to develop fast and elegant websites."
    },
    {
        field: "INTERNSHIP", 
        logo: "https://cdn.discordapp.com/attachments/918024642860548126/1092101830378536980/download_1.jpeg",
        name: "Rentyaar",
        link: "https://www.rentyaar.com/?search=all",
        duration: "Feb 2023 - Present",
        workexp1: "~ Frontend Developer Intern.",
        workexp2: "~ Collaborated with team to redesign website.",
        workexp3: "~ Collaborated with team to upgrade architecture."
    },
    {
        field: "HACKATHON", 
        logo: "https://cdn.discordapp.com/attachments/918024642860548126/1092097697697243187/download.jpeg",
        name: "Buildspace Bounties Winner",
        link: "https://buildspace-bounty.vercel.app",
        duration: "Jan 2023",
        workexp1: "~ Designed a Buildspace Bounties Landing Page.",
        workexp2: "~ Won $200 for best project."
    },
    {
        field: "OPENSOURCE PROGRAM", 
        logo: "https://cdn.discordapp.com/attachments/918024642860548126/1092102679041421392/27850350.png",
        name: "GirlScript SoC'22",
        link: "https://gssoc.girlscript.tech",
        duration: "March 2022 - May 2022",
        workexp1: "~ Worked on 2 proejcts and 3 PRs merged.",
        workexp2: "~ Reached above 150 Rank in PR Merge Ranklist."
    },
    {
        field: "STUDENT CHAPTER", 
        logo: "https://snehil.dev/images/experience/ieee.png",
        name: "IEEE SRMIST",
        link: "https://www.instagram.com/ieeesrmist",
        duration: "April 2022 - Present",
        workexp1: "~ Technical Team Lead at Web & App Team.",
        workexp2: "~ Working on Internal Club Projects.",
        workexp3: "~ Mentored aspiring developers at Webture - Full Stack Developer Bootcamp."
    },
    {
        field: "COLLEGE CLUB", 
        logo: "https://avatars.githubusercontent.com/u/33686558?s=280&v=4",
        name: "TEDx SRMIST",
        link: "https://www.instagram.com/tedxsrmist",
        duration: "August 2022 - Present",
        workexp1: "~ Member at Technical Team.",
        workexp2: "~ Working on Internal Club Projects.",
    },
    {
        field: "WEB3 EVENT", 
        logo: "https://media.glassdoor.com/sqll/2957938/coindcx-squareLogo-1632632394907.png",
        name: "UNFOLD 2022",
        link: "https://www.unfold2022.com",
        duration: "August 2022",
        workexp1: "~ Created a Crowd Funded Real Estate NFT Marketplace.",
    },
]

export default details;